/* 🤖 this file was generated by svg-to-ts */
export const siriusDesktop: {
  name: 'desktop';
  data: string;
} = {
  name: 'desktop',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style="display: block;"><path fill-rule="evenodd" clip-rule="evenodd" d="M12.75 18.75h6.75a2.25 2.25 0 0 0 2.25-2.25V6a2.25 2.25 0 0 0-2.25-2.25h-15A2.25 2.25 0 0 0 2.25 6v10.5a2.25 2.25 0 0 0 2.25 2.25h6.75v1.5H9a.75.75 0 0 0 0 1.5h6a.75.75 0 0 0 0-1.5h-2.25v-1.5Zm7.5-2.25a.75.75 0 0 1-.75.75h-15a.75.75 0 0 1-.75-.75V15h16.5v1.5ZM3.75 6v7.5h16.5V6a.75.75 0 0 0-.75-.75h-15a.75.75 0 0 0-.75.75Z" fill="currentColor"/></svg>`
};
